module.exports = __webpack_public_path__ + "img/bg2.5014de45.jpg";